import React from 'react';
import { UserIcon, MapPinIcon, BookIcon, TrendingUpIcon } from 'lucide-react';
export function AuthorProfile() {
  return <div className="w-full bg-[#F0F2F4] border border-[#E0E0E0] rounded-lg p-6 mb-8 mt-8" data-id="element-1">
      <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-2">
        <div className="flex-shrink-0" data-id="element-3">
          <div className="w-24 h-24 bg-[#1B5E20] rounded-full flex items-center justify-center text-white text-3xl font-serif shadow-sm" data-id="element-4">
            KT
          </div>
        </div>

        <div className="flex-1" data-id="element-5">
          <h1 className="text-2xl font-serif font-bold text-gray-900 mb-1" data-id="element-6">
            Khoanh Nam Ta, MD
          </h1>

          <div className="flex items-center gap-2 text-gray-700 mb-3 text-sm" data-id="element-7">
            <MapPinIcon className="w-4 h-4 text-[#4CAF50]" data-id="element-8" />
            <span data-id="element-9">
              Department of Urology, University Medical Center, Germany
            </span>
          </div>

          <div className="flex flex-wrap gap-2 mb-4" data-id="element-10">
            <span className="px-2 py-1 bg-white border border-[#E0E0E0] text-xs font-medium text-gray-600 rounded" data-id="element-11">
              Urologic Oncology
            </span>
            <span className="px-2 py-1 bg-white border border-[#E0E0E0] text-xs font-medium text-gray-600 rounded" data-id="element-12">
              Prostate Cancer Research
            </span>
            <span className="px-2 py-1 bg-white border border-[#E0E0E0] text-xs font-medium text-gray-600 rounded" data-id="element-13">
              Minimally Invasive Surgery
            </span>
          </div>

          <div className="flex gap-6 text-sm border-t border-[#E0E0E0] pt-4 mt-2" data-id="element-14">
            <div className="flex items-center gap-2" data-id="element-15">
              <BookIcon className="w-4 h-4 text-gray-400" data-id="element-16" />
              <span className="text-gray-600" data-id="element-17">Publications:</span>
              <span className="font-semibold text-gray-900" data-id="element-18">104</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-19">
              <TrendingUpIcon className="w-4 h-4 text-gray-400" data-id="element-20" />
              <span className="text-gray-600" data-id="element-21">h-index:</span>
              <span className="font-semibold text-gray-900" data-id="element-22">14</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}